export enum Reports {
  USERS_TIME_LOG = 1,
  JOB_REPORT = 2,
}
